import PageWrapper from "../../shared/wizard/PageWrapper";
import ToggleDiv from "../components/ToggleDiv";
import { states } from "../../../constants/data";
import Styles from "../AnonForms.module.css";
import { yesNo, yesNoUnsure } from "../../../constants/options";
import { textToBoolean } from "../../../utilities/dataUtilities";

function OtherProperty({ fields, utilities }) {

  const {
    createWizInput,
    createToggleInput,
    createNoLabelInput,
    createNoLabelSelect,
    createTextArea
  } = utilities;

  return (
    <PageWrapper legendInfo="Property Damaged: ">
      <div className={Styles.inputContainer}>
        {createToggleInput(fields.damageToProperty, "100%", yesNoUnsure, true)}
        
      </div>
      {textToBoolean(fields.damageToProperty.value) && (
        <>
          <div className={Styles.inputContainer}>
            <ToggleDiv>
              {createToggleInput(fields.whoOwnsProperty, "100%", yesNo, true)}
            </ToggleDiv>
          </div>

          {fields.whoOwnsProperty.value && (
            <div className={`${Styles.fadeIn} ${Styles.labelInputContainer}`}>
              <p className={Styles.sectionLabel}>Property Owner Information:</p>
              <div className={Styles.inputContainer}>
                {createNoLabelInput(fields.propertyOwnerFirstName, "50%", Styles.anonInput)}
                {createNoLabelInput(fields.propertyOwnerLastName, "50%", Styles.anonInput)}
                {createNoLabelInput(fields.propertyOwnerAddress, "50%", Styles.anonInput)}
              </div>
              <div className={Styles.inputContainer}>
                {createNoLabelInput(fields.propertyOwnerCity, "100%", Styles.anonInput)}
                {createNoLabelSelect(fields.propertyOwnerState, "100%", states, Styles.anonSelect, "Select a State")}
                {createNoLabelInput(fields.propertyOwnerZipcode, "100%", Styles.anonInput)}
              </div>
              <div className={Styles.inputContainer}>
                {createNoLabelInput(fields.propertyOwnerCounty, "100%", Styles.anonInput)}
                {createNoLabelInput(fields.propertyOwnerPhone, "100%", Styles.anonInput)}
              </div>
              <div className={Styles.formRow}>
                {createTextArea(fields.propertyOwnerDescribeProperty, "100%", true, Styles.damageText)}
              </div>
              <div className={Styles.formRow}>
                {createTextArea(fields.propertyOwnerDamageProperty, "100%", true, Styles.damageText)}
              </div>
              <div className={Styles.inputContainer}>
              {createWizInput(fields.propertyOwnerEstimateOfDamage, "15rem", `${Styles.estimate} ${Styles.anonInput}`)}
              </div>
            </div>
          )}
        </>
      )}
    </PageWrapper>
  );
}

export default OtherProperty;
